import { render } from "./HomeView.vue?vue&type=template&id=31abdc56"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=31abdc56&lang=scss"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__